module.exports = __webpack_public_path__ + "img/icon-01-subscriptionAsset 7.35a6deb0.svg";